import { extraFormat, ExtraFormatReturn } from '../utilities/missions/extra-format';
import { proFormat, ProFormatReturn } from '../utilities/missions/pro-format';
import { workWindow, WorkWindowReturn } from '../utilities/missions/work-window';

export class MissionsUtilityHandler {
    private _extraFormat: ExtraFormatReturn;
    private _proFormat: ProFormatReturn;
    private _workWindow: WorkWindowReturn;

    constructor(lang: string) {
        this._extraFormat = extraFormat(lang);
        this._proFormat = proFormat(lang);
        this._workWindow = workWindow();
    }

    get extraFormat() {
        return this._extraFormat;
    }

    get proFormat() {
        return this._proFormat;
    }

    get workWindow() {
        return this._workWindow;
    }
}
